import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import JobListScreen from "./component/jobList";
import { apiCall } from "../../../utils/httpClient";
import ENDPOINTS from "../../../utils/apiEndPoints";
import Loader from "common/loader";
import { useDispatch, useSelector } from "react-redux";
import base64 from "base-64";
import apiEndPoints from "../../../utils/apiEndPoints";
import { serchServiceCitySelect } from "../../../reduxStore/action/usersActions";

function JobList() {
  const resetRef = useRef(0)
  const serviceRef = useRef([])
  const dispatch = useDispatch();

  const serviceRoute = useSelector((store) => store.serviceDetail);
  const [socListData, setSocListData] = useState([]);

  const [pageCount, setPageCount] = useState(1);
  const [itemOffset, setItemOffset] = useState("0");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [baseUrl, setBaseUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resetIsLoading, setResetIsLoading] = useState(false);
  const [citiesList, setCitiesList] = useState([]);
  const [serviceList, setServiceList] = useState(serviceRef.current);

  const [selectedCity, setSelectedCity] = useState("");
  const [selectedService, setSelectedSoc] = useState("");

  const [searchCityList, setSearchCityList] = useState([]);
  const [cityListShow, setCityListShow] = useState(false);
  const [cityName, setCityName] = useState("");
  const [serviceName, setServiceName] = useState("");

  const [searchSocList, setSearchSocList] = useState([]);
  const [socListShow, setSocListShow] = useState(false);
  const [selectServiceName, setSelectSocName] = useState("");
  const [formError, setFormError] = useState();
  // const [bucket_Img_url, setBucket_Img_url] = useState();
  useEffect(() => {
    getSocDataList(itemOffset);
  }, []);

  async function getSocDataList(offset) {

    if (resetRef.current != 1) {
     
      var params = {
          serviceid: selectedService != ""
          ? selectedService : "",
          cityid:selectedCity != "" ? selectedCity :"",
          limit: itemsPerPage,
          offset: String(offset),
      };
    } else {

      var params = {
        serviceid: "",
        cityid: "",
        limit: itemsPerPage,
        offset: offset,
      };
      setSelectedSoc("");
      setSelectedCity("");
    }
    setIsLoading(true);
    setResetIsLoading(true);
    const { data } = await apiCall(
      "POST",
      ENDPOINTS.GETLISTJOBSEARCH,
      params
    );
    if (data.status == 200) {
      setSocListData(data.data.services);
      setSocListData(data.data.services);
      setPageCount(Math.ceil(data.data.total_data / itemsPerPage));
      setIsLoading(false);
      setResetIsLoading(false)
    } else {
      setSocListData([]);
      setIsLoading(false);
      setResetIsLoading(false)
    }
  }
  const handlePageClick = (event) => {
    // const newOffset = (event.selected * itemsPerPage) % serviceListData.length;
    const newOffset = event.selected * itemsPerPage;
    setItemOffset(newOffset);
    getSocDataList(newOffset);
  };



  // -------------------------------------------- city ----------------------------------

  function handleSelectCity(cityname,state_id) {

    document.getElementById("citySearch").value = cityname+', '+state_id;
    setCityName(cityname+', '+state_id);
    setCityListShow(false);
    setSearchCityList([]);
  }

  async function handleCitySearch(city = "") {
    if (city != "" && city.length >= 3) {
      // console.log('search ==>', city)
      const params = { cityname: city };
      const { data } = await apiCall(
        "POST",
        apiEndPoints.GETCITIESLIST,
        params
      );
      if (data.status == 200) {
        setSearchCityList(data.data);
      } else {
        setSearchCityList([]);
      }
      setCityListShow(true);
    } else {
      setSearchCityList([]);
      setSelectedCity("");
      setCityListShow(false);
    }
  }

  async function handlesocSearch(item) {
    if (item != '' && item.length >= 3) {
      const params = { servicename: item };
      const { data } = await apiCall(
        "POST",
        apiEndPoints.GETSERVICESOCLIST,
        params
      );
      if (data.status == 200) {
        setSearchSocList(data.data);
      } else {
        setSearchSocList([]);
      }
      setSocListShow(true);
    } else {
      serviceRef.current = []
      setSocListShow(false);
      setSearchSocList([]);
      setSelectedSoc('');
    }
  }

  function handleSelectSoc(item) {
    setSelectSocName(item);
    document.getElementById("serviceSearch").value = item;
    setSocListShow(false);
    setSearchSocList([]);
  }

  function resetDetail() {
    resetRef.current = 1
   /*  dispatch(
      serchServiceCitySelect({
        service: "",
        servicename: "",
        city: "",
        cityname: "",
      })
    ); */
    setCityName('')
    setServiceName("")
    document.getElementById('citySearch').value = ''
    document.getElementById('serviceSearch').value = ''
    setFormError({})
    getSocDataList(itemOffset);
  }


  function searchValidation() {
    let error = {};
    let formErrorData = false;

   /*  if (!selectedService) {
      formErrorData = true;
      error["service"] = "Service is required";
    }
    if (!selectedCity) {
      formErrorData = true;
      error["city"] = "City is required";
    } */
    // if (!serviceRoute.serviceDetail.service && !selectedService) {
    //   formErrorData = true;
    //   error["service"] = "Service is required";
    // }
    // if (!serviceRoute.serviceDetail.city && !selectedCity) {
    //   formErrorData = true;
    //   error["city"] = "City is required";
    // }
    setFormError(error);
    return formErrorData;
  }
  function searchSocDataList() {
    if (!searchValidation()) {
      resetRef.current = 0
      getSocDataList('0')
    }
  }


  function manageSearchSoc(item) {
    if (item == '') {
      setSelectedSoc('')
      setSocListShow(false);
      setSearchSocList([]);
    }
  }

  function manageSearchCity(item) {
    if (item == '') {
      setSelectedCity('')
      setSearchCityList([]);
      setCityListShow(false);
    }
  }

 
  return (
    <JobListScreen
      resetDetail={resetDetail}
      serviceRoute={serviceRoute}
      setCityListShow={setCityListShow}
      cityListShow={cityListShow}
      handleSelectCity={handleSelectCity}
      handleCitySearch={handleCitySearch}
      setSearchCityList={setSearchCityList}
      searchCityList={searchCityList}
      getSocDataList={getSocDataList}
      socListData={socListData}
      handlePageClick={handlePageClick}
      pageCount={pageCount}
      baseUrl={baseUrl}
      citiesList={citiesList}
      serviceList={serviceList}
      setSelectedCity={setSelectedCity}
      selectedCity={selectedCity}
      setSelectedSoc={setSelectedSoc}
      selectedService={selectedService}
      cityName={cityName}
      serviceName={serviceName}
      handlesocSearch={handlesocSearch}
      searchSocList={searchSocList}
      socListShow={socListShow}
      handleSelectSoc={handleSelectSoc}
      isLoading={isLoading}
      resetIsLoading={resetIsLoading}
      searchSocDataList={searchSocDataList}
      formError={formError}
      setFormError={setFormError}
      manageSearchSoc={manageSearchSoc}
      itemOffset={itemOffset}
      manageSearchCity={manageSearchCity}
    />
  );
}
export default JobList;
